import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { FloorPlanImage, FloorPlanAfterImage, floorPlanExtractionActions } from "../../reducers/floorPlanExtraction";

import FloorPlanFormSome from "./FloorPlanFormSome";
import BandReplacementFormSome from "./BandReplacementFormSome";

// サブモードの型定義
type SubMode = 'extraction' | 'bandReplacement';

// State型定義
interface RootState {
  floorPlanExtraction: {
    sourceImage: FloorPlanImage | null;
    afterImages: FloorPlanAfterImage[];
    isLoading: boolean;
    // 帯替え用
    bandSourceImage: FloorPlanImage | null;
    bandInputSource: 'upload' | 'extraction_result';
    [key: string]: any;
  };
  [key: string]: any;
}

// mapStateToPropsの型定義
function mapStateToProps(state: RootState) {
  return { ...state.floorPlanExtraction };
}

// コンポーネントのProps型定義
interface FloorPlanFormProps {
  sourceImage: FloorPlanImage | null;
  afterImages: FloorPlanAfterImage[];
  isLoading: boolean;
  bandSourceImage: FloorPlanImage | null;
  bandInputSource: 'upload' | 'extraction_result';
}

const FloorPlanForm = (props: FloorPlanFormProps) => {
  const { sourceImage, afterImages, isLoading, bandSourceImage, bandInputSource } = props;
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [subMode, setSubMode] = useState<SubMode>('extraction');

  // モード切替ハンドラー
  const handleSubModeChange = (mode: SubMode) => {
    if (!isLoading) {
      setSubMode(mode);
    }
  };

  // 帯替えで使うボタンのハンドラー
  const handleUseForBandReplacement = () => {
    // 間取り抜き出し結果を帯替えで使用するように設定
    dispatch(floorPlanExtractionActions.setBandInputSource('extraction_result'));
    setSubMode('bandReplacement');
  };

  // 間取り抜き出しの結果があるかどうか
  const hasExtractionResult = afterImages.length > 0;

  return (
    <div className="max-w-8xl w-full mx-auto pt-1 pb-3 px-4 sm:px-6 md:px-8 text-[#2d2d2d]">
      {/* サブタブ */}
      <div className="flex space-x-1 mb-2">
        <button
          onClick={() => handleSubModeChange('extraction')}
          className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${
            subMode === 'extraction'
              ? 'bg-white text-orange-600 border border-b-0 border-gray-300'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={isLoading}
        >
          間取り抜き出し
        </button>
        <button
          onClick={() => handleSubModeChange('bandReplacement')}
          className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${
            subMode === 'bandReplacement'
              ? 'bg-white text-orange-600 border border-b-0 border-gray-300'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={isLoading}
        >
          帯替え
        </button>
      </div>

      {/* コンテンツエリア */}
      {subMode === 'extraction' && (
        <FloorPlanFormSome
          onUseForBandReplacement={handleUseForBandReplacement}
          hasExtractionResult={hasExtractionResult}
        />
      )}

      {subMode === 'bandReplacement' && (
        <BandReplacementFormSome
          useExtractionResult={bandInputSource === 'extraction_result'}
        />
      )}
    </div>
  );
};

export default connect(mapStateToProps)(FloorPlanForm);
